<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'setup_2.page_title'}}</h1>

     <form>
          <child-deceased [(ng-model)]="data.aboutChild.isChildDeceased"></child-deceased>

          <div class="padding-top-10" id="isUnableToCertify">
               <ng-radio [item-list]="items.yesNoList" id="isUnableToCertifyRadio"
                    [(ng-model)]="data.eligibility.isUnableToCertify" 
                    [(ng-error)]="error_isUnableToCertify" 
               >
                    <h2 translate>{{'setup_2.questions.isUnableToCertify'}}</h2>
               </ng-radio>
          </div>
          <div class="padding-top-1em">
               <accordion header="setup_2.accordion3.header">
                    <div translate>
                         {{"setup_2.accordion3.text1"}}
                    </div>
                    <div class="padding-top-1em" [innerHTML]="'setup_2.accordion3.text2' | translate"></div>
               </accordion>
          </div>
          <div aria-live='polite'>
          <div [hidden]="!(data.eligibility.isUnableToCertify === 'Y')" class="padding-top-10">
               <information outer-style="width:100%">
                    <ng-container *ngTemplateOutlet="additionalDoc"></ng-container>
               </information>
          </div>
          </div>
      </form>

      <div class="btn-div">

          <div [hidden]="hideCancelBtn()==false">
               <button class="btn-next" title="{{Button.Next_alt | translate}}" (click)="onNextClick()" translate>
                  {{Button.Next}}
               </button>
          </div>

          <div  [hidden]="hideCancelBtn()">
            <div class="button-top">
                  <button class="btn-next2" title="{{Button.Next_alt | translate}}" (click)="onNextClick()" translate>
                        {{Button.Next}}
                  </button>
            </div>
            <div class="button-bottom">
                        <button class="btn-cancel2" title="{{Button.Cancel_alt | translate}}" (click)="onCancelApplication()" translate>
                              {{Button.Cancel}}
                        </button>
            </div>
          </div>
      </div>
</div>



<ng-template id="additionalDoc" #additionalDoc>
     <h3>
          {{'setup_2.additional_doc.header' | translate}}
     </h3>
     <div translate class="padding-top-1em">
          {{ "setup_2.additional_doc.text1" }}
     </div>
     <div translate class="padding-top-1em">
          {{ "setup_2.additional_doc.text2" }}
     </div>
     <div [innerHTML]="'setup_2.additional_doc.step1_header' | translate" class="padding-top-1em"></div>
     <div class="pad-left">
          {{ "setup_2.additional_doc.step1_text1" | translate }}
          <a routerLink="/{{ orgContactPath }}" href="#" 
               title="{{'setup_2.org_contact_title' | translate}}">{{"setup_2.additional_doc.step1_text2" | translate}}</a>
          {{ "setup_2.additional_doc.step1_text3" | translate }}
     </div>

     <div [innerHTML]="'setup_2.additional_doc.step2_header' | translate" class="padding-top-1em"></div>
     <div class="pad-left">
          {{ "setup_2.additional_doc.step2_text1" | translate }}
     </div>

     <div [innerHTML]="'setup_2.additional_doc.step3_header' | translate" class="padding-top-1em"></div>
     <div class="pad-left">
          {{ "setup_2.additional_doc.step3_text1" | translate }}
     </div>

     <div [innerHTML]="'setup_2.additional_doc.step4_header' | translate" class="padding-top-1em"></div>
     <div [innerHTML]="'setup_2.additional_doc.step4_text1' | translate" class="pad-left"></div>

     <div [innerHTML]="'setup_2.header_note' | translate" class="padding-top-1em">
     </div>
     <div [innerHTML]="'setup_2.additional_doc.note_text' | translate">
     </div>
</ng-template>